<template>
  <v-app id="inspire">
    <v-dialog v-model="dialog" persistent max-width="390">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            ><h3>Early build ahead!</h3></v-toolbar>
            <br><v-card-text>
              Our knowledge base editor and viewer are currently in early access, meaning it’s not yet ready for production purposes yet. While we're hard at work debugging and pushing styling improvements, feel free to play around and give us your feedback!

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="black darken-1"
                text
                @click="backToDashboard()"
              >
                &lt; Go back
              </v-btn>
              <v-btn
                color="primary darken-1"
                @click="proceed()"
              >
                Continue
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    <v-app-bar app flat style="background-color:#27AAE1">
      <v-btn onclick="window.location='/'" color="white" plain large>
        <v-icon>mdi-chevron-left</v-icon> Return to dashboard
      </v-btn>
      <v-spacer />
      <v-toolbar-title style="color:#fff;font-weight:500;font-size:20pt"> Knowledge Base Editor </v-toolbar-title>

      <v-spacer />
      <v-spacer />
      <v-toolbar-title style="color:#fff"> {{former.published? 'Published' : 'Draft'}} <v-icon color="white" >{{former.published? 'mdi-flag-checkered' : 'mdi-feather'}}</v-icon></v-toolbar-title>
    </v-app-bar>
    <v-main class="grey lighten-3" style="padding: 16px 0px 0px !important">
      <v-container>
        <v-row>
          <v-col cols="12" sm="4">
            <v-sheet rounded="lg" min-height="268">
              <KnowledgeBaseStepper
                :key="componentKey"
                ref="kbstepper"
                v-on:bubba="bubbaEmit"
                v-on:kb_id="kbIdEmit"
                v-on:categories="categoriesEmit"
                v-on:categoryContentUpdated="categoryContentUpdatedEmit"
                v-on:darkTheme="themeEmit"
                v-on:button="buttonEmit"
                v-bind:page_categories_loaded="page_categories_loaded"
                v-bind:former="former"
                v-bind:client="client"
                v-bind:buttonx="button1"
                v-bind:buttony="button2"
                v-bind:kb_id="id"
                v-bind:imgr="imgr"
                v-bind:cards="cards"
                v:bind:img_hold="logo"
                v-bind:replace_logo="replace_logo"
                v-bind:categories_list="category_items"
                v-bind:category_value="selected_categories"
                v-bind:persisted_custom_domain="custom_domain"
                v-bind:persisted_custom_domain_verified="custom_domain_verified"
                v-bind:category_content_updated="category_content_updated"
              />
            </v-sheet>
          </v-col>
          <v-col cols="12" sm="8">
            <v-card class="mx-auto" height="100%">
              <v-toolbar :dark="former.dark_theme" flat>
                <v-img
                  lazy-src="@/assets/logo.png"
                  max-height="45"
                  contain
                  aspect-ratio="1"
                  v-bind:src="imgr"
                ></v-img>

                <v-toolbar-title></v-toolbar-title>

                <v-spacer v-if="button2.show"></v-spacer>
                <v-spacer v-if="!button2.show && button1.show"></v-spacer>

                <v-btn
                  v-if="button1.show"
                  large
                  color="#27282A"
                  style="color:#fff;font-size:14pt;font-family:'Open Sans'"
                  class="mr-4"
                  @click="buttonInfo(button1)"
                  >{{ button1.label }}</v-btn
                >
                <v-btn
                  v-if="button2.show"
                  large
                  color="#27282A"
                  style="color:#fff;font-size:14pt;font-family:'Open Sans'"
                  class="mr-4"
                  @click="buttonInfo(button2)"
                  >{{ button2.label }}</v-btn
                >
              </v-toolbar>
              <v-container fluid>
                <v-row >
                  <v-col cols="12">
                    <br><h2 style="color:#07293d;font-family:'Open Sans Bold';position:relative;" class="text-center">{{former.title}}</h2>
                    <div class="text-center" style="position:relative;top:12px;font-weight:400;color:#07293d">{{former.description}}</div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <br>
                    <SearchIndex v-bind:kb_id="id" v-bind:client="client" v-bind:mode="'development'"  />
                  </v-col>
                </v-row>
                <draggable v-model="cards" class="row" @end="checkMove(true, true)">
                  <!--:move="checkMove" -->
                  <v-col
                    id="sortable"
                    v-for="(card, idx) in cards"
                    :key="card.id"
                    :cols="computeColumns(card.flex, idx)"
                  >
                    <v-card
                      height="100%"
                      :class="card.bubba_class"
                    >
                      <v-img
                        v-if="card.include_gradient"
                        :src="card.src"
                        :class="card.bubba_class"
                        class="blue accent-1"
                        :height="75"
                      >
                        <v-card-title v-text="card.title"></v-card-title>
                      </v-img>
                      <v-img v-else>
                        <v-card-title v-text="former.title"></v-card-title>
                        <v-card-subtitle
                          v-text="former.description"
                        ></v-card-subtitle>
                      </v-img>

                      <v-list :dense="contentLength(card) > 6">
                        <v-subheader>{{ card.description }}</v-subheader>
                        <v-list-item-group
                          v-model="selected_content"
                          color="primary"
                        >
                          <v-list-item
                            v-for="contenter in card.content"
                            :key="getKey(card.id, contenter.id)"
                            :value="getCardKey(card.id, contenter)"
                          >
                            <v-list-item-icon>
                              <v-icon
                                color="primary"
                                v-text="computedIcon(contenter.type)"
                              ></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                v-text="contenter.title"
                              ></v-list-item-title>

                              <v-list-item-subtitle
                                v-text="contenter.description"
                              ></v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                      
                      <v-card-actions v-if="card.include_footer">
                        <v-spacer></v-spacer>
                        <v-btn icon>
                          <v-icon>mdi-heart</v-icon>
                        </v-btn>
                        <v-btn icon>
                          <v-icon>mdi-bookmark</v-icon>
                        </v-btn>
                        <v-btn icon>
                          <v-icon>mdi-share-variant</v-icon>
                        </v-btn>
                      </v-card-actions>
                      
                    </v-card>
                  </v-col>
                </draggable>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-snackbar v-model="snackbar" :timeout="timeout" :centered="true">
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>

      <v-snackbar
        v-model="selected_content_snackbar"
        vertical
        :timeout="selected_content_timeout"
        :centered="true"
      >
        The <strong>{{ selected_content.type }}</strong> with the title:
        <strong>"{{ selected_content.title }}"</strong> will open in a new
        window with menu links for that that category.
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="selected_content_snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-snackbar
        v-model="button_snackbar"
        vertical
        :timeout="button_timeout"
        :top="true"
      >
        {{ button_text }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="button_snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-main>
  </v-app>
</template>
<script>
import cognitoAuth from "@/plugins/cognito";
import KnowledgeBaseStepper from "./KnowledgeBaseStepper";
import SearchIndex from "./SearchIndex";
import { ApolloClient, InMemoryCache } from "@apollo/client/core";
import { gql } from "@apollo/client/core";
import draggable from "vuedraggable";
import config from '../config'
export default {
  data: () => ({
    dialog: false, 
    componentKey: 0, 
    idToken: "",
    //pageSize: 10,
    //snackbar
    email: "",
    snackbar: false,
    page_categories_loaded: false, 
    text: "The category order has been updated.",
    timeout: 2000,
    //end snackbar
    //selected_content_snackbar
    selected_content_snackbar: false,
    selected_content_timeout: 4000,
    //end selected_content_snackbar
    //button_snackbar
    button_snackbar: false,
    button_text: "The button will open the following link: ",
    button_timeout: 4000,
    //end button_snackbar
    drag: false,
    dragger: {},
    id: "",
    lister: "",
    client: {},
    toolbar_title: "",
    selected_content: "",
    category_content_updated: false, 
    bubba_class: "text-center align-start",
    cdn: "",
    placeholder_img: "placeholder.jpg",
    img_hold: '',
    custom_domain: '', 
    custom_domain_verified: '', 
    former: {
      title: "Knowledge Base Title",
      description: "Subheader (optional info)",
      published: false,
      dark_theme: false,
      uses_custom_domain: false
    },
    button1: {},
    button2: {},
    links: [
      { title: "Knowledge Base", link: "/kbs" },
      { title: "Categories", link: "" },
      "Tutorials",
      "Quizzes",
    ],
    replace_logo:false,
    retrieved_categories: [],
    real_cards: new Map(),
    source_cards: new Map(),
    organization_id: '', 
    cards: [],
    sample_cards: function () {
      let cards = new Map();
      cards.set("cat1", {
        id: "cat1",
        title: "Sample Category 1",
 //       src: "https://cdn.vuetifyjs.com/images/cards/road.jpg",
        flex: 6,
        classer: "text-center",
        heighter: "370px",
        include_footer: true,
        include_gradient: true,
      });
      return cards;
    },
    category_items: [
//      { title: "Category 1", id: "cat1" },
    ],
    selected_categories: [
//      { title: "Category 1", id: "cat1" },
    ],
    overlay: true,
  }),
  computed: {
    imgr: function () {
      //console.log("img_hold", this.img_hold==null)
      if((this.img_hold==''|| this.img_hold==null) || this.organization_id=='' ){
        //console.log("placeholder")
        return `${this.cdn}${this.placeholder_img}`;
      }else{
        //console.log("full img url")
        return `${this.cdn}${config.RETRIEVE_FILEPATH_CDN}/${this.organization_id}/${this.img_hold}`;
      }
    },
  },
  
  async mounted() {
    let self = this;
    this.$cognitoAuth.getIdToken((err, idToken) => {
      if (err) {
        console.error("App: Couldn't get the session:", err, err.stack);
        return;
      }
      //console.log(idToken)
      self.idToken = idToken;
    });
    //TODO - Review or remove by 3/1/2021
    cognitoAuth.getUserAttributes(function (err, user_attributes) {
    //  console.log("User attributes", user_attributes);
      self.organization_id=user_attributes["custom:organization_id"];
      self.email = user_attributes;
    });
    (this.cdn = `${process.env.VUE_APP_KB_CDN}`),
      (this.client = new ApolloClient({
        uri: `${process.env.VUE_APP_GRAPHQL_HTTP}`,
        cache: new InMemoryCache(),
        headers: {
          authorization: `Bearer ${self.idToken}`,
        },
      }));
    if(this.$route.query.setup=='true'){
      this.setup()
    }
    this.accepted_beta_experience = localStorage.getItem("accepted_beta_experience") || false;
    if(!this.accepted_beta_experience){
      this.dialog=true;
    }
    await this.findCategoriesForOrganization()
    //console.log("$route", this.$route.params.id);
    if (this.$route.params.id != undefined ) {
      this.id = this.$route.params.id.trim();
      console.log(
        "Id exists, attempting to retrieve. If any issues, will set up for new."
      );
      this.findKnowledgeBaseById(this.id);
    } else {
      // console.log("id is undefined, setting up for new kb")
      //per spec check if kb exists, use it, ie one per account (for now).
      this.findKnowledgeBases();
    }
    
  },
  components: {
    KnowledgeBaseStepper,
    SearchIndex,
    draggable,
  },
  props: ["keycloak"],
  watch: {
    selected_content(valzer) {
      console.log(valzer);
      this.selected_content_snackbar = true;
    },
  },
  methods: {
    proceed(){
      this.dialog=false;
      this.accepted_beta_experience = true
      localStorage.setItem("accepted_beta_experience", true)
      console.log("LocalStorage accepted_beta_experiece", localStorage.getItem("accepted_beta_experience"))
    },
    backToDashboard(){
      this.dialog=false;
      window.location="/"
    },
    setup(){
      this.button1 = {
        label: "Button 1",
        link: "http://www.example.com",
        open_in_new_window: true,
        show: true,
      };
      this.button2 = {
        label: "Button 2",
        link: "http://www.example.com",
        open_in_new_window: true,
        show: true,
      };
      this.overlay = false;
      if (this.cards.length == 0) {
        this.cards.push(this.sample_cards().get("cat1"));
      }
    },
    contentLength(card) {
      if (card.content) {
        return card.content.length;
      } else {
        return 0;
      }
    },
    findKnowledgeBases() {
      this.client
        .query({
          query: gql`
            query CheckForExistingKb {
              knowledge_base(order_by: { created_at: asc }, limit: 1) {
                id
              }
            }
          `,
        })
        .then((result) => {
          console.log("knowledgebase:", result.data);
          console.log("knowledgebase:", result.data.knowledge_base.length);
          if (result.data.knowledge_base.length > 0) {
            console.log("returning knowledge base");
            return result.data.knowledge_base[0];
          } else {
            console.log("returning undefined");
            return undefined;
          }
        })
        .then((result) => {
          //console.log("result->", result)
          //console.log("/kbs/kb/" + result.id )
          if(result==undefined){
            this.setup()
          }else{
            window.location.href = "/kbs/kb/" + result.id;
          }
        });
    },
    findKnowledgeBaseById(id) {
      let self=this;
      this.client
        .query({
          query: gql`
            query GetKnowledgeBase($id: uuid!) {
              knowledge_base_by_pk(id: $id) {
                id
                title
                description
                created_at
                organization_id
                header_buttons
                logo
                uses_custom_domain
                custom_domain{
                  custom_domain
                  domain_ownership_verified
                }
                published
                dark_theme
                categories(order_by: {order: asc}){
                  category_id
                  category{
                    id
                    title
                    content
                  }
                  include_footer
                  include_gradient
                }
              }
            }
          `,
          variables: {
            id: id,
          },
        })
        .then((result) => {
          console.log("knowledgebase:", result.data);
          let kb = result.data.knowledge_base_by_pk;
          if (kb.header_buttons) {
            this.button1 = kb.header_buttons.header_button_1;
            this.button2 = kb.header_buttons.header_button_2;
          } else {
            console.log("No buttons defined, using the defaults.");
          }
          if (kb.categories) {
            self.selected_categories = [];
            kb.categories.forEach(category=>{
              console.log("categories loop", category.category)
              self.selected_categories.push({
                id:category.category.id,
                title:category.category.title
              })
            })
            this.categoriesEmit(self.selected_categories)
            /*
            this.cards = kb.categories;
            this.cards.forEach((category) => {
              this.selected_categories.push({
                id: category.id,
                title: category.title,
              });
            });
            */
          }
          this.former.title = kb.title
          this.former.description = kb.description
          this.former.published=kb.published
          this.former.dark_theme=kb.dark_theme
          this.former.uses_custom_domain=kb.uses_custom_domain
          if(kb.custom_domain!=undefined){
            this.custom_domain=kb.custom_domain['custom_domain']
            this.custom_domain_verified=kb.custom_domain['domain_ownership_verified']
          }
          this.img_hold = kb.logo;
          this.overlay = false;
          this.componentKey += 1;
        });
    },
    buttonInfo: function (button) {
      this.button_text = `This button has the label: '${button.label}' and will open the link: '${button.link}' in a new window.`;
      this.button_snackbar = true;
    },
    checkMove: function(reorder, persist=true){
      console.log("cm a")
      let self=this;
      let categoriesInOrder=[]
      console.log("cm b")
      //first remove existing join table entries
      console.log("cards length:", this.cards.length)
      this.cards.forEach((card, idx)=>{
        console.log("checkMove card is ", card)
        let obj={}
        obj.knowledge_base_id=self.id
        obj.category_id=card.id
        obj.order=idx
        obj.include_footer=card.include_footer;
        obj.include_gradient=card.include_gradient;
        categoriesInOrder.push(obj)
      })
      console.log("cm c")
      if(persist){
        this.persistCategoriesInOrder(categoriesInOrder, reorder)
      }
      console.log("cm d")
    },
    persistCategoriesInOrder(categoriesInOrder, reorder){
      this.client.mutate({
        mutation: gql`
          mutation RemoveExistingKbCategoriesInPreparationForReorderOrRecreation($kb_id: uuid = "") {
            delete_knowledge_bases_categories(where: {knowledge_base_id: {_eq: $kb_id}}) {
              affected_rows
            }
          }
        `,
        variables: {
          kb_id: this.id
        }
      }).then((result) => {
        console.log(result)
        //insert new entries in order
        this.client.mutate({
          mutation: gql`
            mutation MyMutation($objects: [knowledge_bases_categories_insert_input]!) {
              insert_knowledge_bases_categories(objects: $objects) {
                returning {
                  category_id
                  knowledge_base_id
                }
              }
            }
          `, 
          variables: {
            objects: categoriesInOrder
          }
          }).then((result) =>{
            console.log("Category order and content saved.", result);
              if (reorder) {
                this.text = "The category order has been updated.";
                this.snackbar = true;
              } else {
                this.category_content_updated=true;
                //this.text = "The knowledge base category content has been updated.";
              }
          })  
      })
    },
    themeEmit(valzer){
      this.former.dark_theme=valzer
    },
    categoryContentUpdatedEmit(){
      this.category_content_updated=false;
    },
    categoriesEmit(valzer, persister=false) {
      console.log("after the emit: ", valzer);
      let hold = valzer.map((cat) => {
        return cat.id;
      });
      //hold.push("bubba");
      console.log("after the map", hold);
      let cardReplacer = new Map();
      console.log("a")
      this.cards.forEach((card) => {
        if (hold.includes(card.id)) {
          console.log("adding_:", card.id);
          cardReplacer.set(card.id, card);
        }
      });
      console.log("b")
      console.log("real_cards", this.real_cards.length)
      //now add in any newly selected categories
      //inefficent loop structure, but we must maintain the order of the categories selected
      hold.forEach((category_id) => {
        this.real_cards.forEach((card)=> {
          if(category_id==card.id){
            cardReplacer.set(card.id, card);
          }
        })
      });
      console.log("c")
  /*
      this.real_cards.forEach((card) => {
        console.log("Real cards:", card.id);
        if (hold.includes(card.id)) {
          console.log("adding_rc:", card.id);
          cardReplacer.set(card.id, card);
        }
      });
      */
      //just as a getting started crutch, let user add back in sample cards
      console.log("d")
      hold.forEach((holdId) => {
        if (this.sample_cards().has(holdId)) {
          //console.log("adding_sc:", holdId);
          cardReplacer.set(holdId, this.sample_cards().get(holdId));
        }
      });
      console.log("e")
      this.cards = [...cardReplacer.values()];
      console.log("f")
      this.checkMove(false, persister); //
      console.log("g")
    },
    getKey(cardid, contentid) {
      return `${cardid}_${contentid}`;
    },
    getCardKey(cardid, content) {
      return {
        category_id: cardid,
        content_id: content.id,
        type: content.type,
        description: content.description,
        title: content.title,
      };
    },
    async findCategoriesForOrganization() {
      let self=this;
      const response = await this.client
        .query({
          query: gql`
            query GetOrganizationCategories($offset: Int, $limit: Int) {
              category(
                offset: $offset
                limit: $limit
                order_by: { created_at: asc }
              ) {
                id
                title
                description
                created_at
                content
              }
            }
          `,
          variables: {
            offset: 0,
            limit: 10,
          },
        });
        
        let categories = response.data.category;
        console.log("findCategoriesForOrg: categories.length after the query", categories.length)
        categories.forEach((category) => {
          let catter = {};
          catter.id = category.id;
          catter.title = category.title;
          catter.description = category.description;
          catter.src = "";
          catter.flex = 12;
          catter.heighter = "370px";
          catter.include_footer = false;
          (catter.include_gradient = true),
            (catter.content = category.content);
          this.real_cards.set(catter.id, catter);
          this.category_items.push({
            title: `${catter.title}`,
            id: `${catter.id}`,
          });
        });
         
        console.log("Setting page_categories_loaded to true")
        self.page_categories_loaded=true;
    },
    computedIcon(type) {
      if (type == "tutorial") {
        return "mdi-book-play";
      } else if (type == "quiz") {
        return "mdi-check-decagram-outline";
      } else {
        return "mdi-flag";
      }
    },
    computeHeight(height, idx) {
      if (idx == 0) {
        return height;
      }
      if (this.cards.length < 4) {
        return "100%";
      } else {
        return height;
      }
    },
    /*eslint-disable no-unused-vars */ 
    computeColumns(flex, idx) {
      //console.log(flex, idx)
      //if(idx==0)
      //if (idx == 0) {
       // return 12;
      //}
      //console.log("Compute columns:", this.cards.length)
      switch (this.cards.length) {
        case 1:
          return 12;
        case 2:
        case 4:
          return 6;
        case 3:
        case 6:
          return 4;
        default:
          return 12;
      }
    },
    bubbaEmit(valzer) {
      this.replace_logo=false
      this.img_hold = valzer;
    },
    kbIdEmit(valzer) {
//      this.id = valzer;
      window.location.href = "/kbs/kb/" + valzer + '?setup=true';
    },
    buttonEmit(button, sequence) {
      //console.log("In Layoutbutton, button is ", button);
      if (sequence == 1) {
        this.button1 = button;
      } else {
        this.button2 = button;
      }
      this.$forceUpdate();
      //this.$refs.kbstepper.saveButton()
    },
  },
};
</script>
<style scoped>
.div-1 {
  background-color: gray;
}


</style>